import { IMealPlan } from "../../types/plan";
import { deleteApi, getApi, postApi } from "../api";
import { PlanDb } from "../indexeddb/planDb";
import { getStringFromLocalStorage } from "../localStorage";

const apiUrl = import.meta.env.VITE_API_URL as string;
const apiToken = getStringFromLocalStorage("idToken");

export class PlanStore {
  private static instance: PlanStore | null = null;
  private _readyPromise: Promise<void>;
  private db = new PlanDb();
  public plans: IMealPlan[] = [];
  private constructor() {
    this._readyPromise = this.load();
  }

  public static getInstance(): PlanStore {
    if (!PlanStore.instance) {
      PlanStore.instance = new PlanStore();
    }
    return PlanStore.instance;
  }

  public ready(): Promise<void> {
    return this._readyPromise;
  }

  private async load(): Promise<void> {
    await this.db.initDB();
    await this.getPlans();
  }

  public async getPlans(clear: boolean = false, startDate?: string, endDate?: string): Promise<void> {
    try {
      const params: any = { household: "true" };

      // Add date range filtering if provided
      if (startDate && endDate) {
        params.date = `between.${startDate}_${endDate}`;
      }

      const local = await this.db.getPlans();
      if (local.length === 0 || clear) {
        const api = await getApi(apiUrl, "mealplan", apiToken, params);
        await this.db.addPlans(api, clear);
        this.plans = api;
      } else {
        this.plans = local;
      }
    } catch (e: any) {
      console.log(e);
    }
  }

  public async upsertPlan(plan: IMealPlan): Promise<void> {
    const data: { [key: string]: string | number } = {};
    data.user_email = plan.user.email;
    data.date = plan.date;
    data.meal = plan.meal;

    try {
      if (plan.recipe.name != "--") {
        data.recipe_name = plan.recipe.name;
        data.number_people = plan.number_people;

        data.is_leftovers = plan.is_leftovers.toString();
        await postApi(apiUrl, "mealplan", data, apiToken);
        await this.db.updatePlan(plan);
      } else {
        await deleteApi(apiUrl, "mealplan", undefined, apiToken, data);
        // await this.db.deletePlan(plan);
      }
    } catch {
      throw new Error("Error setting MealPlan");
    }
  }

  // public async getEmptyRecipes(): Promise<void> {
  //   try {
  //     const api = await getApi(apiUrl, "recipe", apiToken, { empty: "true" });
  //     this.emptyRecipes = api;
  //   } catch (e: any) {
  //     console.log(e);
  //   }
  // }

  // public async addRecipe(recipeName: string, defaultPeople: number): Promise<void> {
  //   try {
  //     await postApi(apiUrl, "recipe", { name: recipeName, default_people: defaultPeople }, apiToken);
  //     this.getHouseholdRecipes(true);
  //   } catch (e: any) {
  //     console.log(e);
  //   }
  // }
}
